/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  GET_APPROVE_TRANSACTION,
  GET_APPROVE_TRANSACTION_BY_ID,
  GET_EXECUTED_TRANSACTION,
  GET_REPROVED_TRANSACTION,
  MULTIPLE_APPROVAL_SUCCESS,
  MULTIPLE_APPROVAL_RESULT,
} from '~/actions/actionTypes';

const initialState: reducers.ApproveTransactionReducer = {
  list: null,
  transactionDetail: null,
  transactionExecuted: null,
  transactionReproved: null,
  countExecuted: null,
  countReproved: null,
  countPendingApproval: null,
  multipleApprovalSuccess: false,
  multipleApprovalResult: null,
};

const accountReducer = (
  state = initialState,
  action: any
): reducers.ApproveTransactionReducer => {
  switch (action.type) {
    case GET_APPROVE_TRANSACTION:
      return {
        ...state,
        list: action.payload.rows,
        countPendingApproval: action.payload.count,
      };
    case GET_APPROVE_TRANSACTION_BY_ID:
      return {
        ...state,
        transactionDetail: action.payload,
      };
    case GET_EXECUTED_TRANSACTION:
      return {
        ...state,
        transactionExecuted: action.payload.rows,
        countExecuted: action.payload.count,
      };
    case GET_REPROVED_TRANSACTION:
      return {
        ...state,
        transactionReproved: action.payload.rows,
        countReproved: action.payload.count,
      };
    case MULTIPLE_APPROVAL_SUCCESS:
      return {
        ...state,
        multipleApprovalSuccess: action.payload,
      };
    case MULTIPLE_APPROVAL_RESULT:
      return {
        ...state,
        multipleApprovalResult: action.payload,
      };
    default:
      return state;
  }
};

export default accountReducer;
